import IDatePickerPayload from '../types/DatePickerPayload';

export function requiredValidation<F extends { [field: string]: any } = {}>(
  value: any,
  args: { message?: string },
  formData: F
) {
  return {
    validate: () => {
      if (typeof value === 'string') {
        value = value.trim();
      }
      return ![undefined, null, '', false].includes(value) && !Number.isNaN(value);
    },
    message: 'Required field',
  };
}

export function requiredDateValidation<F extends { [field: string]: any } = {}>(
  value: IDatePickerPayload | null,
  args: { message?: string },
  formData: F
) {
  const actualValue = value && value.value;

  return {
    validate: () => {
      return actualValue !== null;
    },
    message: 'Required field',
  };
}

export function dateFormatValidation<F extends { [field: string]: any } = {}>(
  value: IDatePickerPayload | null,
  args: { message?: string },
  formData: F
) {
  return {
    validate: () => {
      if (value !== null) {
        // dateObj.value is only not null when the datepicker validates the input value.
        return value.inputValue === '' || value.value !== null;
      } else {
        return true;
      }
    },
    message: 'Invalid date format',
  };
}
